import { api } from 'src/pages/APIs';
import AbstractApiService from '../abstractApiService';

export default class SupplierCalculationsApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async createCalculation(
    org_id: string,
    sub_org_id: string,
    supplier_id: string,
    supplier_name: string,
    calculation: string,
  ): Promise<any> {
    const formData = new FormData();
    formData.append('org_id', org_id);
    formData.append('sub_org_id', sub_org_id);
    formData.append('supplier_id', supplier_id);
    formData.append('supplier_name', supplier_name);
    formData.append('calculation', calculation);

    return super.post(api.create_calculation, formData);
  }

  public async deleteCalculation(
    org_id: string,
    sub_org_id: string,
    supplier_name: string,
    calculation: string,
  ): Promise<any> {
    const formData = new FormData();
    formData.append('org_id', org_id);
    formData.append('sub_org_id', sub_org_id);
    formData.append('supplier_name', supplier_name);
    formData.append('calculation', calculation);

    return super.delete(api.delete_calculation, formData);
  }

  public async getCalculations(
    org_id: string,
    sub_org_id: string,
    supplier_name: string,
  ): Promise<any> {
    const formData = new FormData();
    formData.append('org_id', org_id);
    formData.append('sub_org_id', sub_org_id);
    formData.append('supplier_name', supplier_name);

    return super.post(api.get_calculations, formData);
  }
}
